module.exports = __webpack_public_path__ + "static/media/cocina-gourmet.8ff29056.png";